'use client'
import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { FaLine } from 'react-icons/fa'
import { MdPhoneAndroid } from "react-icons/md";
import { FaWhatsappSquare } from "react-icons/fa";
import tailwindConfig from '@tailwind.config'
import { company } from '@constants/company';
import { MdPhoneIphone } from "react-icons/md";
import { useSession } from 'next-auth/react'

const ProjectBottomBar = ({ property, dictionary, phoneNumber = null }) => {
    const { data: session } = useSession()

    const [userId, setUserId] = useState(null)

    useEffect(() => {
        const setUserData = () => {
            if (session?.user) {
                // console.log(session?.user)
                setUserId(session?.user.id)
            }
        }
        setUserData()
    }, [session])

    const handleScroll = (e) => {
        e.preventDefault();
        const target = document.getElementById('target-anchor');
        target.scrollIntoView({ behavior: 'smooth' });
    };

    // const handleContactClick = async (contact) => {
    //     // e.preventDefault()
    //     const { sendClickContact } = await import('@services/sendClickContact')
    //     await sendClickContact(userId, property.id, property.agentId, property.saleType, contact)
    // }

    return (
        <div className='sm:hidden z-[50] w-full bg-maincolor/90 flex justify-between rounded-t-xl bottom-0 fixed border-t p-1 border-t-third'>
            {company.lineUrl && (
                <div className='w-[45px] min-w-[45px] h-[45px] mr-1'>
                    <Link href={company.lineUrl} className='w-full h-full flex flex-col justify-center bg-gradient-to-r from-[#32CD32] to-[#32CD32] items-center rounded-full shadow-sm drop-shadow-md' target="_blank" /*onClick={() => handleContactClick('line')}*/ >
                        <FaLine
                            color={tailwindConfig.theme.extend.colors.light}
                            size={30}
                            className=''
                        />
                    </Link>
                </div>
            )}
            {company.whatsappUrl && (
                <div className='w-[45px] min-w-[45px] h-[45px] mr-1'>
                    <Link href={company.whatsappUrl} className='w-full h-full flex flex-col justify-center bg-gradient-to-r from-[#25D366] to-[#25de68] items-center rounded-full shadow-sm drop-shadow-md' target="_blank" /*onClick={() => handleContactClick('whatsapp')}*/ >
                        <FaWhatsappSquare
                            color={tailwindConfig.theme.extend.colors.light}
                            size={30}
                            className=''
                        />
                    </Link>
                </div>
            )}
            {company.phoneUrl && (
                <div className='w-[45px] min-w-[45px] h-[45px] mr-1'>
                    <Link href={`tel:${company.phoneUrl}`} className='w-full h-full flex flex-col justify-center bg-red-800 items-center rounded-full shadow-sm drop-shadow-md' target="_blank" /*onClick={() => handleContactClick('whatsapp')}*/ >
                        <MdPhoneAndroid
                            color={tailwindConfig.theme.extend.colors.light}
                            size={30}
                            className=''
                        />
                    </Link>
                </div>
            )}
            <div onClick={handleScroll} className='w-full h-[45px] flex justify-center items-center bg-third text-light font-bold rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.12)] mx-[1px]'>
                <span>{dictionary.sendAnEnquiry}</span>
            </div>
        </div>
    )
}

export default ProjectBottomBar